import Loading from "components/Loading";
import { useEffect, useMemo, useRef } from "react";
import { useGetAllNotesQuery } from "store/services/notesCustomApi";
import NoteView from "./NoteView";
import styles from "./NoteArea.module.scss";

interface NoteAreaProps {
  appoinmentId: number;
}

const NoteArea = ({ appoinmentId }: NoteAreaProps) => {
  const notesContainerRef = useRef<HTMLDivElement>(null);

  const { data: notes, isLoading } = useGetAllNotesQuery({
    appointmentId: appoinmentId,
  });

  useEffect(() => {
    notesContainerRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }, []);

  const note = useMemo(() => {
    return notes?.[0];
  }, [notes]);

  return (
    <div ref={notesContainerRef} className={styles["container"]}>
      {isLoading && <Loading className={styles.loading} />}
      {!isLoading && !note && (
        <div className={styles["no-notes"]}>
          This session doesn't have any notes attached.
        </div>
      )}
      {note && <NoteView note={note} />}
    </div>
  );
};

export default NoteArea;
